import { render, staticRenderFns } from "./NaturalReportLayout.vue?vue&type=template&id=6c0dbe18&scoped=true"
import script from "./NaturalReportLayout.vue?vue&type=script&lang=ts"
export * from "./NaturalReportLayout.vue?vue&type=script&lang=ts"
import style0 from "./NaturalReportLayout.vue?vue&type=style&index=0&id=6c0dbe18&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0dbe18",
  null
  
)

export default component.exports